import makeStyles from '@material-ui/core/styles/makeStyles'
import React from 'react'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(() => ({
  typo: {
    marginBottom: '12px',
  },
}))

export default ({ children, ...rest }) => (
  <Typography className={useStyles().typo} variant="subtitle1" {...rest}>
    {children}
  </Typography>
)
